<template>
	<div class="release">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>发布闲具</span>
			<span></span>
		</div>
		<div class="main">
			<div class="tupian-img">
				<div v-for="(item,nn) in formArrayB" :key="nn">
					<img :src="'http://backstage.jbj-china.com.cn/uploads'+item" alt="图片" class="uploadimg" preview="1">
					<van-icon name="clear" @click="delImgg(nn)" class="delte" />
				</div>
				<van-uploader multiple :max-count="20" :after-read="fileListoB" :accept="'image/*'" v-show="formArrayB.length <= 20" />
				</van-uploader>
			</div>
			<van-field v-model="message" rows="2" autosize type="textarea" placeholder="在这里详细描述一下宝贝的转手原因,入手渠道,规格尺寸,新旧程度和使用感受吧~"
			 show-word-limit />
		</div>
		<div class="footer">
			<div class="van-cell van-field">
				<div class="van-cell__title van-field__label">
					<span>发布者</span>
				</div>
				<div class="van-cell__value">
					<van-radio-group v-model="radio" class="van-radios">
						<van-radio name="1" checked-color="#F1452F" icon-size="1rem">个人转让</van-radio>
						<van-radio name="2" checked-color="#F1452F" icon-size="1rem">商家出售</van-radio>
					</van-radio-group>
				</div>
			</div>
		</div>
		<div class="footer">
			<van-field v-model="title" label="商品标题" placeholder="请输入标题" />
			<van-field readonly clickable label="商品成色" :value="news" placeholder="选择成色" @click="show=true" right-icon="arrow" />
			<van-field v-model="number" type="digit" label="商品数量" placeholder="请输入数量" />
			<van-field v-model="norms" label="商品规格" placeholder="请输入规格" />
		</div>
		<div class="footer">
			<van-field v-model="money" @blur="formatter" label="商品价格" :error-message="erroMessage" type="number" placeholder="请输入价格">
				<div slot="right-icon">
					<span>元</span>
				</div>
			</van-field>
			<van-field v-model="tel" type="tel" label="联系方式" placeholder="请输入联系方式" />
			<van-field v-model="address" readonly type="text" label="所在地区" placeholder="请选择所在地区" @click="showAds=true">
				<div slot="right-icon" style="display:flex;align-items:center;color:#F1452F">
					<img src="../../assets/address.png" style="width:0.8rem" alt="">
					<div>&nbsp;定位</div>
				</div>
			</van-field>
			<van-field v-model="addressMsg" label="详细地址" placeholder="请输入详细地址" />
		</div>
		<div class="submit">
			<van-button round type="default" size="small" @click="back()">取消</van-button>
			<van-button round color="#F1452F" size="small" @click="submit">立即发布</van-button>
		</div>
		<div>{{ceshi}}</div>
		<van-popup v-model="show" position="bottom">
			<van-picker show-toolbar :columns="columns" @cancel="show=false" @confirm="onConfirm" />
		</van-popup>
		<!-- 城市选择 -->
		<van-popup v-model="showAds" position="bottom" :style="{ 'height': '95%' }">
			<Map @close="close" @sites="sites"></Map>
		</van-popup>
	</div>
</template>

<script>
	import Map from '@/components/map';
	import {compressImage} from '../../assets//js/compressImage';
	const myImage = new Image();
	var formData = new FormData();
	export default {
		data() {
			return {
				fileListA: [],
				fileListB: [],
				formArrayA: [],
				formArrayB: [],
				fileList: [],
				message: '',
				title: '',
				news: '',
				norms: '',
				number: '',
				money: '',
				tel: '',
				address: '',
				columns: ['五成新', '六成新', '七成新', '八成新', '九成新', '全新'],
				show: false,
				radio: "1",
				ceshi: '',
				erroMessage: '',
				address: '',
				addressMsg: '',
				showAds: false,
				province: '', //省
				city: '', //市
				area: '', //区
				lat: '',
				lng: ''
			}
		},
		components: {
			Map
		},
		methods: {
			delImgg(index) {
				if (isNaN(index) || index >= this.formArrayB.length) {
					return false
				}
				let tmp = []
				for (let i = 0, len = this.formArrayB.length; i < len; i++) {
					if (this.formArrayB[i] !== this.formArrayB[index]) {
						tmp.push(this.formArrayB[i])
					}
				}
				this.formArrayB = tmp
			},
			async afterDelete(index) {},


			fileListoB(file) {
				this._compressAndUploadFile(file);
			},
			_compressAndUploadFile(file) {
				let fles = '';
				if (Object.prototype.toString.call(file) === '[object Object]') {
					let arr = []
					arr.push(file);
					fles = arr;
				} else {
					fles = file;
				}
				for (let i = 0; i < fles.length; i++) {
					compressImage(fles[i].content).then(result => {
						console.log('压缩后', result); // result即为压缩后的结果
						var fileListoB = new FormData();
						fileListoB.append("file", result);
						file.cusContent = result;
						this.upload_d(fileListoB, (res) => {
							this.formArrayB.push(res)
							this.$previewRefresh();
						})
					})
				}
			},
			//接收子组件返回的地址
			sites(e) {
				AMap.plugin('AMap.Geocoder', () => {
					// 这里通过高德 SDK 完成。
					var geocoder = new AMap.Geocoder({
						radius: 1000,
						extensions: "all"
					});
					geocoder.getAddress([e.location.lng, e.location.lat], (status, result) => {
						if (status === 'complete' && result.info === 'OK') {
							if (result && result.regeocode) {
								// 具体地址
								self.address = result.regeocode.formattedAddress;
								// 省
								self.province = result.regeocode.addressComponent.province;
								// 市
								self.city = result.regeocode.addressComponent.city;
								// 区
								self.district = result.regeocode.addressComponent.district;
								this.address = self.province + self.city + self.district;
								this.province = self.province;
								this.city = self.city;
								this.area = self.district;
							}
						} else {
							this.$toast('系统繁忙,请重试');
						}
					})
				});
				this.addressMsg = e.address;
				this.lat = e.location.lat;
				this.lng = e.location.lng;
				this.showAds = false;
			},
			//关闭选择地址
			close(res) {
				this.showAds = res;
			},
			submit() {
				const toast = this.$toast.loading({
					duration: 0,
					forbidClick: true,
					message: '提交中',
					loadingType: 'spinner'
				});
				if (this.formArrayB.length == 0) {
					this.$toast('请上传图片！');
					return false;
				};
				if (this.message == '') {
					this.$toast('描述不能为空！');
					return false;
				};
				if (this.title == '') {
					this.$toast('标题不能为空！');
					return false;
				};
				if (this.news == '') {
					this.$toast('成色不能为空！');
					return false;
				};
				if (this.norms == '') {
					this.$toast('规格不能为空！');
					return false;
				};
				if (this.number == '' || this.number < 1) {
					this.$toast('请填写正确数量！');
					return false;
				};
				if (this.money == '') {
					this.$toast('价格不能为空！');
					return false;
				};
				if (this.tel == '') {
					this.$toast('手机号不能为空！');
					return false;
				};
				if (this.tel && (!(/^[1][345789]\d{9}$/).test(this.tel) || !(/^[1-9]\d*$/).test(this.tel) ||
						this.tel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				};
				if (this.addressMsg == '') {
					this.$toast('请填写详细地址！');
					return false;
				};
				let formData = new FormData();
				for (let key in this.fileList) {
					formData.append('file[]', this.fileList[key].file);
				}

				this.$axios.post(baseUrl + '/mobile/Fta/ftaAdd', {
					image: this.formArrayB,
					category_id: this.$route.query.id,
					title: this.title,
					tel: this.tel,
					specifications: this.norms,
					price: this.money,
					new_old: this.news,
					num: this.number,
					address: this.addressMsg,
					content: this.message,
					category: this.radio,
					province: this.province,
					city: this.city,
					area: this.area,
					lat: this.lat,
					lng: this.lng,
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					console.log(res)
					if (res.data.code === 5) {
						this.$toast.clear();
						this.$router.push({
							path: '/home_undete'
						})
					}
				}).catch(() => {
					console.log(err);
				})
			},
			onConfirm(value) {
				this.news = value;
				this.show = false;
			},
			formatter(event) {
				if (parseInt(event.target.value) > 1999) {
					this.erroMessage = '* 大于1999的值页面内将显示“面议”';
				} else {
					this.erroMessage = '';
				}
			}
		}
	}
</script>

<style scoped>
	.van-cell:not(:last-child)::after {
		border: none;
	}

	.main div>img {
		position: relative;
		top: 1.7rem;
		left: 2rem;
		-o-object-fit: cover;
		object-fit: cover;
		width: 80px;
		height: 80px;
		overflow: hidden;
		border-radius: 8px;
	}

	.tupian-img {
		display: flex;
		flex-wrap: wrap;
		/* padding-bottom: 2rem; */
	}

	.release {
		padding-top: 2rem;
	}

	.release .title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 0.8rem;
		padding: 0.5rem 1rem;
		box-sizing: border-box;
		background: #fff;
		width: 100%;
		position: fixed;
		z-index: 9999;
	}

	.release .title span:nth-child(1) {
		color: #ababab;
	}

	.release .title span:nth-child(2) {
		font-size: 0.9rem;
		color: #000;
	}

	.release .title .van-button span {
		color: #fff;
	}

	.release .van-field {
		padding-left: 1rem;
		box-sizing: border-box;
	}

	.release .main {
		background: #fff;
		text-align: left;
		border-radius: 0 0 0.5rem 0.5rem;
	}

	.release .main .van-uploader {
		margin: 1.6rem -1.7rem 0 1.9rem;
	}

	.release .footer {
		margin-top: 1rem;
		border-radius: 0.5rem;
		overflow: hidden;
	}

	.release .footer>.van-cell {
		text-align: left;
		border-bottom: 1px solid #f0eff5;
		font-size: 0.75rem;
	}

	.release .submit {
		width: 100%;
		height: 2rem;
		margin: 0.5rem 0;
	}

	.release .submit .van-button {
		width: 45%;
	}

	.release .footer .van-radios {
		font-size: 0.75rem;
		display: flex;
		justify-content: space-between;
	}

	.release .address {
		padding: 0;
		font-size: 0.75rem;
	}

	.release .address .van-cell__title {
		overflow: hidden;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	.release .address span {
		display: inline-block;
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.shop {
		padding-top: 2rem;
	}

	.tupian-img .delte {

		position: relative;
		top: -41px;
		left: 1.1rem;
		color: #969799;
		z-index: 88;
		font-size: 18px;
		background-color: #fff;
		border-radius: 100%;

	}

	.default>span {
		width: 50px;
		color: #969799;
		font-size: 18px;
		z-index: 999;
		background-color: #fff;
		border-radius: 100%;

	}

	.default span>img {
		position: relative;
		top: 1.7rem;
		left: 2rem;
		object-fit: cover;
		width: 80px;
		height: 80px;
		overflow: hidden;
		border-radius: 8px;
	}

	.default>>>.van-uploader__upload {
		margin: 23px 8px 8px 2px !important;
	}

	.shop .container .van-cell {
		font-size: 0.75rem;
		border-top: 1px solid #ebedf0;
	}

	.shop .van-field__label span {
		width: 100%;
	}

	.shop .container,
	.shop .article,
	.shop .footer {
		margin: 0.8rem;
		border-radius: 0.3rem;
		overflow: hidden;
		text-align: left;
	}

	.shop .article .van-panel__header,
	.shop .footer .van-panel__header {
		border-bottom: 1px solid #ebedf0;
	}

	.shop .van-cell:not(:last-child)::after {
		border: 0;
	}

	.shop .article .van-field__word-limit {
		padding: 0 1rem 1rem 0;
		box-sizing: border-box;
	}

	.shop .article .van-field__word-limit span {
		color: #F1452F;
		font-weight: bold;
	}

	.shop .van-uploader {
		margin: 0.7rem 0 0 1.9rem;
	}

	.shop .tips {
		font-size: 0.75rem;
		color: #c4c4c4;
	}

	.shop .footer .tips {
		padding: 0 0.7rem 0.5rem 0;
		text-align: right;
	}

	.shop .submit {
		height: 2rem;
		width: 100%;
		margin-bottom: 0.8rem;
	}

	.shop .submit .van-button {
		width: 80%;
	}

	.shop .address {
		padding: 0;
		border-top: 0 !important;
	}

	.shop .van-radios {
		font-size: 0.75rem;
		width: 65%;
		justify-content: space-between;
		display: flex;
	}

	.defaka>>>.van-uploader__upload {
		margin: 23px 8px 8px 2px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/release.vue